export const BASE_API_URL = () => {
  return 'https://api.beta.readysetvr.com/api/1';
};
